module.exports = __webpack_public_path__ + "img/real.45b95475.png";